import { render } from "./Renstra.vue?vue&type=template&id=db46a0c4"
import script from "./Renstra.vue?vue&type=script&lang=js"
export * from "./Renstra.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__